import React from 'react'
import { useUser } from '@clerk/react-router'
import { observer } from 'mobx-react-lite'
import { prioritySummaryStore } from 'shared/stores/prioritySummaryStore'
import s from './styles/HeaderContent.module.scss'
import { useHeaderContent } from './hooks/useHeaderContent'

const HeaderContent = observer(({
	rows = [],
	sessions = [],
	pendingReviewTotal = 0,
	studentRepliesCount = 0,
	className = '',
	onSummaryClick,
}) => {
	const { user } = useUser()
	const displayName =
		user?.fullName ||
		user?.firstName ||
		user?.username ||
		user?.primaryEmailAddress?.emailAddress ||
		'Counselor'

	const {
		priorityAssignmentsCount,
	} = useHeaderContent({ rows, sessions })
	const assignmentsCount =
		Number(prioritySummaryStore.counts.assignments) || priorityAssignmentsCount

	return (
		<div className={[s.wrap, className].filter(Boolean).join(' ')}>
			<div className={s.left}>
				<h2 className={s.title}>Good morning, {displayName}!</h2>
				<p className={s.summaryLine}>
					<button type="button" className={s.summaryLink} onClick={() => onSummaryClick?.('essays')}>
						{pendingReviewTotal} essays waiting review
					</button>
					<button type="button" className={s.summaryLink} onClick={() => onSummaryClick?.('assignments')}>
						{assignmentsCount} assignment updates
					</button>
					<button type="button" className={s.summaryLink} onClick={() => onSummaryClick?.('feedback')}>
						{studentRepliesCount} student replies
					</button>
				</p>
			</div>
		</div>
	)
})

export default HeaderContent
